import Controller from '@ember/controller';
import { service } from '@ember/service';
import type { FilterValues } from 'walden-fast/types/filters';
import type FilterService from 'walden-fast/services/filter';
import type { DashboardModel } from 'walden-fast/routes/app/dashboard';

export default class AppDashboardController extends Controller<DashboardModel> {
  @service('filter') declare filterService: FilterService;

  declare model: DashboardModel;

  get powerBiFilters(): FilterValues | null {
    return this.filterService.currentFilters;
  }
}
